export const digitsOnly = (value) => String(value || "").replace(/\D/g, "");

const stripToE164Like = (value) => {
  if (value == null) return "";
  let raw = String(value).trim();
  if (!raw) return "";
  raw = raw.replace(/[^\d+]/g, "");
  if (raw.startsWith("00")) raw = `+${raw.slice(2)}`;
  return raw;
};

export const detectCountry = (value) => {
  const raw = stripToE164Like(value);
  const digits = digitsOnly(raw);
  if (!digits) return "";
  if (raw.startsWith("+1") || (/^1\d{10}$/.test(digits) && !raw.startsWith("+90"))) return "US";
  if (/^5\d{9}$/.test(digits) || /^05\d{9}$/.test(digits) || /^90\d{10}$/.test(digits) || raw.startsWith("+90")) return "TR";
  if (raw.startsWith("+")) return "INTL";
  if (/^5\d{8,10}$/.test(digits)) return "TR";
  return "";
};

const turkishNational = (digits) => {
  if (/^5\d{9}$/.test(digits)) return digits;
  if (/^05\d{9}$/.test(digits)) return digits.slice(1);
  if (/^90\d{10}$/.test(digits)) return digits.slice(2);
  return "";
};

const usNational = (digits) => {
  if (/^1\d{10}$/.test(digits)) return digits.slice(1);
  if (/^\d{10}$/.test(digits) && !digits.startsWith("5")) return digits;
  return "";
};

const formatTr = (national) =>
  `+90 ${national.slice(0, 3)} ${national.slice(3, 6)} ${national.slice(6, 8)} ${national.slice(8, 10)}`;

const formatUs = (national) => `+1 (${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`;

export const formatPhoneForDisplay = (value) => {
  const digits = digitsOnly(stripToE164Like(value) || value);
  if (!digits) return "";
  const country = detectCountry(value) || (/^5\d{9}$/.test(digits) ? "TR" : "");
  if (country === "TR" || /^5\d{9}$/.test(digits) || /^05\d{9}$/.test(digits) || /^90\d{10}$/.test(digits)) {
    const national = turkishNational(digits) || (digits.startsWith("5") && digits.length === 10 ? digits : "");
    if (national) return formatTr(national);
  }
  if (country === "US" || stripToE164Like(value).startsWith("+1")) {
    const national = usNational(digits) || (digits.length === 10 ? digits : digits.slice(-10));
    if (national.length === 10) return formatUs(national);
  }
  return String(value || "").trim() || digits;
};
